export default function(id: string): string {
    return id.replace(/^0+/, '');
}